import cx from 'classnames2';
import React from 'react';
import { Divider } from '../../Divider';
import styles from './BlockListItem.scss';
export var BlockListItem = function BlockListItem(_ref) {
  var id = _ref.id,
      label = _ref.label,
      selected = _ref.selected,
      focused = _ref.focused,
      lastItem = _ref.lastItem,
      dataTest = _ref.dataTest,
      onClick = _ref.onClick,
      onMouseEnter = _ref.onMouseEnter;
  return React.createElement("li", {
    id: id,
    "aria-selected": selected,
    role: "option",
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    "data-test": dataTest
  }, React.createElement(Divider.ListItem, null), React.createElement("div", {
    className: cx(styles.container, selected && styles.selected, focused && !selected && styles.focused)
  }, label), lastItem && React.createElement(Divider.ListItem, null));
};